export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

// Auth
export const ApiLogin = {
	method: 'post',
	url: '/api/Auth/LoginOwner'
}
export const ApiCheckAuth = {
	method: 'post',
	url: 'api/Auth/CheckAuth'
}
export const ApiRegister = {
	method: 'post',
	url: 'api/Auth/RegisterOwner'
}

export const ApiRegisterUser = {
	method: 'post',
	url: 'api/Auth/Register'
}
export const ApiCheckUsername = {
	method: 'post',
	url: 'api/User/CheckUsername'
}

// Company
export const ApiGetCompanyList = {
	method: 'post',
	url: '/api/Company/GetList'
}
export const ApiGetCompanyById = {
	method: 'post',
	url: 'api/Company/GetById'
}
export const ApiCreateCompany = {
	method: 'post',
	url: 'api/Company/Create'
}
export const ApiUpdateCompany = {
	method: 'post',
	url: 'api/Company/Update'
}
export const ApiDeleteCompany = {
	method: 'post',
	url: 'api/Company/Delete'
}


// User
export const ApiUpdateUser = {
	method: 'post',
	url: 'api/User/Update'
}
export const ApiGetUserList = {
	method: 'post',
	url: 'api/User/GetList'
}
export const ApiGetUserById = {
	method: 'post',
	url: 'api/User/GetById'
}
export const ApiDeleteUser = {
	method: 'post',
	url: 'api/User/Delete'
}
export const ApiCheckIsAdmin = {
	method: 'post',
	url: 'api/User/CheckIsAdmin'
}
export const ApiGetCompanyAccessDropdown = {
	method: 'post',
	url: 'api/Company/Dropdown'
}

// User Owner
export const ApiGetUserOwnerList = {
	method: 'post',
	url: 'api/User/GetListOwner'
}
export const ApiGetUserOwnerById = {
	method: 'post',
	url: 'api/User/GetUserOwnerById'
}
export const ApiUpdateOwnerUser = {
	method: 'post',
	url: 'api/User/UpdateOwner'
}
export const ApiDeleteOwnerUser = {
	method: 'post',
	url: 'api/User/DeleteOwner'
}













// Brand
export const ApiGetBrandList = {
	method: 'post',
	url: '/api/Brand/GetList'
}
export const ApiGetBrandById = {
	method: 'post',
	url: 'api/Brand/GetById'
}
export const ApiCreateBrand = {
	method: 'post',
	url: 'api/Brand/Create'
}
export const ApiDeleteBrand = {
	method: 'post',
	url: 'api/Brand/Delete'
}

// Product
export const ApiGetProductList = {
	method: 'post',
	url: '/api/Product/GetList'
}
export const ApiGetProductById = {
	method: 'post',
	url: 'api/Product/GetById'
}
export const ApiCreateProduct = {
	method: 'post',
	url: 'api/Product/Create'
}
export const ApiUpdateProduct = {
	method: 'post',
	url: 'api/Product/Update'
}
export const ApiDeleteProduct = {
	method: 'post',
	url: 'api/Product/Delete'
}

// Category
export const ApiGetCategoryList = {
	method: 'post',
	url: '/api/Category/GetList'
}
export const ApiGetCategoryById = {
	method: 'post',
	url: 'api/Category/GetById'
}
export const ApiCreateCategory = {
	method: 'post',
	url: 'api/Category/Create'
}
export const ApiUpdateCategory = {
	method: 'post',
	url: 'api/Category/Update'
}
export const ApiDeleteCategory = {
	method: 'post',
	url: 'api/Category/Delete'
}

// Customer
export const ApiGetCustomerList = {
	method: 'post',
	url: '/api/Customer/GetList'
}
export const ApiGetCustomerById = {
	method: 'post',
	url: 'api/Customer/GetById'
}
export const ApiCreateCustomer = {
	method: 'post',
	url: 'api/Customer/Create'
}
export const ApiUpdateCustomer = {
	method: 'post',
	url: 'api/Customer/Update'
}
export const ApiDeleteCustomer = {
	method: 'post',
	url: 'api/Customer/Delete'
}

// Sales Stock
export const ApiGetSalesStockList = {
	method: 'post',
	url: '/api/SalesStock/GetList'
}
export const ApiGetSalesStockById = {
	method: 'post',
	url: 'api/SalesStock/GetById'
}
export const ApiCreateSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Create'
}
export const ApiUpdateSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Update'
}
export const ApiDeleteSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Delete'
}

// Rental Stock
export const ApiGetRentalStockList = {
	method: 'post',
	url: '/api/RentalStock/GetList'
}
export const ApiGetRentalStockById = {
	method: 'post',
	url: 'api/RentalStock/GetById'
}
export const ApiCreateRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Create'
}
export const ApiUpdateRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Update'
}
export const ApiDeleteRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Delete'
}







// Old File
// Location
export const ApiGetLocationList = {
	method: 'post',
	url: 'api/Location/GetList'
}
export const ApiGetLocationById = {
	method: 'post',
	url: 'api/Location/GetById'
}
export const ApiInsertLocation = {
	method: 'post',
	url: 'api/Location/Create'
}
export const ApiUpdateLocation = {
	method: 'post',
	url: 'api/Location/Update'
}
export const ApiDeleteLocation = {
	method: 'post',
	url: 'api/Location/Delete'
}


// User Location
export const ApiCreateUserLocation = {
	method: 'post',
	url: 'api/UserLocation/Create'
}
export const ApiDeleteUserLocation = {
	method: 'post',
	url: 'api/UserLocation/Delete'
}
export const ApiGetUserLocationByUserId = {
	method: 'post',
	url: 'api/UserLocation/GetByUserId'
}
export const ApiGetAvailableLocationList = {
	method: 'post',
	url: 'api/UserLocation/GetAvailableLocationList'
}

// Dashboard
export const ApiGetDashboardList = {
	method: 'post',
	url: 'api/Dashboard/GetList'
}

export const ApiGetDashboardHeader = {
	method: 'post',
	url: 'api/Dashboard/GetHeader'
}

// Employee
export const ApiGetEmployeeList = {
	method: 'post',
	url: 'api/Employee/GetList'
}
export const ApiGetEmployeeById = {
	method: 'post',
	url: 'api/Employee/GetById'
}
export const ApiInsertEmployee = {
	method: 'post',
	url: 'api/Employee/Create'
}
export const ApiUpdateEmployee = {
	method: 'post',
	url: 'api/Employee/Update'
}
export const ApiDeleteEmployee = {
	method: 'post',
	url: 'api/Employee/Delete'
}
export const ApiGetEmployeeLocationOptions = {
	method: 'post',
	url: 'api/Employee/GetEmployeeLocationOptionList'
}

// Employee Auth
export const ApiGetEmployeeAuthList = {
	method: 'post',
	url: 'api/EmployeeAuth/GetList'
}
export const ApiGetEmployeeAuthById = {
	method: 'post',
	url: 'api/EmployeeAuth/GetById'
}
export const ApiInsertEmployeeAuth = {
	method: 'post',
	url: 'api/EmployeeAuth/Create'
}
export const ApiUpdateEmployeAuth = {
	method: 'post',
	url: 'api/EmployeeAuth/Update'
}
export const ApiDeleteEmployeeAuth = {
	method: 'post',
	url: 'api/EmployeeAuth/Delete'
}

// Employee Location
export const ApiGetEmployeeLocationList = {
	method: 'post',
	url: 'api/EmployeeLocation/GetList'
}
export const ApiCreateEmployeeLocation = {
	method: 'post',
	url: 'api/EmployeeLocation/Create'
}
export const ApiDeleteEmployeeLocation = {
	method: 'post',
	url: 'api/EmployeeLocation/Delete'
}

// Vehicle Brand
export const ApiCreateVehicleBrand = {
	method: 'post',
	url: 'api/VehicleBrand/Create'
}
export const ApiUpdateVehicleBrand = {
	method: 'post',
	url: 'api/VehicleBrand/Update'
}
export const ApiDeleteVehicleBrand = {
	method: 'post',
	url: 'api/VehicleBrand/Delete'
}
export const ApiGetVehicleBrandList = {
	method: 'post',
	url: 'api/VehicleBrand/GetList'
}
export const ApiGetVehicleBrandByIe = {
	method: 'post',
	url: 'api/VehicleBrand/GetById'
}

// Vehicle Color
export const ApiCreateVehicleColor = {
	method: 'post',
	url: 'api/VehicleColor/Create'
}
export const ApiDeleteVehicleColor = {
	method: 'post',
	url: 'api/VehicleColor/Delete'
}
export const ApiGetVehicleColorList = {
	method: 'post',
	url: 'api/VehicleColor/GetList'
}

// Transaction
export const ApiCreateTransaction = {
	method: 'post',
	url: 'api/Transaction/Create'
}
export const ApiUpdateTransaction = {
	method: 'post',
	url: 'api/Transaction/Update'
}
export const ApiDeleteTransaction = {
	method: 'post',
	url: 'api/Transaction/Delete'
}
export const ApiValetReturned = {
	method: 'post',
	url: 'api/Transaction/ValetReturned'
}
export const ApiGetTransactionList = {
	method: 'post',
	url: 'api/Transaction/GetList'
}
export const ApiGetTransactionById = {
	method: 'post',
	url: 'api/Transaction/GetById'
}

// Session
export const ApiGetDailySessionList = {
	method: 'post',
	url: 'api/DailySession/GetList'
}
export const ApiUpdateDailySession = {
	method: 'post',
	url: 'api/DailySession/Update'
}





// Contractor
export const ApiCreateContractor = {
	method: 'post',
	url: 'api/Contractor/Create'
}
export const ApiUpdateContractor = {
	method: 'post',
	url: 'api/Contractor/Update'
}
export const ApiGetContractorList = {
	method: 'post',
	url: 'api/Contractor/GetContractorList'
}
export const ApiGetContractorById = {
	method: 'post',
	url: 'api/Contractor/GetContractorById'
}
export const ApiDeleteContractor = {
	method: 'post',
	url: 'api/Contractor/DeleteContractor'
}
export const ApiGetContractorDropdown = {
	method: 'post',
	url: 'api/Contractor/Dropdown'
}



// User Company
export const ApiInsertUserCompany = {
	method: 'post',
	url: 'api/UserAccess/CreateUserCompany'
}
export const ApiInsertUserMenu = {
	method: 'post',
	url: 'api/UserAccess/CreateUserMenu'
}
export const ApiGetUserCompanyList = {
	method: 'post',
	url: 'api/UserAccess/GetUserCompanyList'
}
export const ApiDeleteUserCompany = {
	method: 'post',
	url: 'api/UserAccess/DeleteUserCompany'
}

// User Access
export const ApiGetUserAccessList = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessList'
}
export const ApiGetUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessByUserId'
}
export const ApiCheckUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/CheckAccess'
}

// Income
export const ApiGetIncomeList = {
	method: 'post',
	url: 'api/Income/GetIncomeList'
}

export const ApiPrintIncomeStatus = {
	method: 'post',
	url: 'api/Income/PrintStatus'
}

export const ApiGetSubconList = {
	method: 'post',
	url: 'api/SubCon/GetSubConList'
}

export const ApiPrintSubConStatus = {
	method: 'post',
	url: 'api/SubCon/PrintStatus'
}

export const ApiGetProductionBankList = {
	method: 'post',
	url: 'api/ProductionBank/GetProductionBankList'
}

export const ApiGetBankList = {
	method: 'post',
	url: 'api/ProductionBank/GetBankList'
}

// Project
export const ApiGetProjectList = {
	method: 'post',
	url: 'api/Project/GetProjectList'
}
export const ApiInsertProject = {
	method: 'post',
	url: 'api/Project/Create'
}
export const ApiUpdateProject = {
	method: 'post',
	url: 'api/Project/Update'
}
export const ApiDeleteProject = {
	method: 'post',
	url: 'api/Project/Delete'
}
export const ApiGetProjectById = {
	method: 'post',
	url: 'api/Project/GetProjectById'
}

// Payment
export const ApiCreatePayment = {
	method: 'post',
	url: 'api/Payment/Create'
}
export const ApiUpdatePayment = {
	method: 'post',
	url: 'api/Payment/Update'
}
export const ApiDeletePayment = {
	method: 'post',
	url: 'api/Payment/Delete'
}
export const ApiGetPaymentById = {
	method: 'post',
	url: 'api/Payment/GetPaymentById'
}
export const ApiGetPaymentList = {
	method: 'post',
	url: 'api/Payment/GetPaymentList'
}
export const ApiGetClientList = {
	method: 'post',
	url: 'api/Payment/GetClientName'
}

// Payment SubContractor
export const ApiCreatePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Create'
}
export const ApiUpdatePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Update'
}
export const ApiDeletePaymentSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/Delete'
}
export const ApiGetPaymentByIdSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetPaymentById'
}
export const ApiGetPaymentListSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetPaymentList'
}
export const ApiGetClientListSubCon = {
	method: 'post',
	url: 'api/PaymentSubContractor/GetClientName'
}






